import { NgModule } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import {
  Globe, Briefcase, Users, TrendingUp, Building, Clock, Wallet, ListChecks, CheckCircle, ChevronRight, Building2, Zap,Info ,Circle ,
  Cpu, Wheat, Menu, X, DollarSign, Star, ArrowRight, MapPin, Phone, Mail, Lock, Eye, Shield, EyeOff, Bell, LogOut, ChartColumn, ChartPie, Activity, Target, Settings, ArrowUpRight, Award, CircleAlert, 
  Calendar,Download ,CreditCard ,FileText ,Plus ,SquarePen ,Trash2 ,Ticket ,Layers ,Check ,ShoppingCart ,Minus ,Tag ,RefreshCcw ,ArrowUp ,Percent ,Search ,Hourglass ,List ,Copy ,Hash ,
  Receipt ,LoaderCircle ,CircleX ,BanknoteArrowDown  ,CloudUpload ,CalendarDays ,Coins ,PiggyBank ,Trophy ,ChevronDown ,UserRoundCog ,User ,Folder ,CalendarX ,Euro ,Send ,
  ShieldCheck ,ArrowLeft ,LogIn ,MailCheck ,TriangleAlert ,CircleQuestionMark ,Inbox ,ClipboardList ,KeyRound 
} from 'lucide-angular';

@NgModule({
  imports: [
    LucideAngularModule.pick({
      Globe,
      Briefcase, Users, TrendingUp, Building, Clock, Wallet, ListChecks, CheckCircle,
      ChevronRight, Building2, Zap, Cpu, Wheat, Menu, X, DollarSign, Star, ArrowRight, MapPin,Circle ,
      Phone, Mail, Lock, Eye, Shield, EyeOff, Bell, LogOut, ChartColumn, ChartPie, Activity, Target, Settings, ArrowUpRight, Award, CircleAlert,Info ,
      Calendar,Download ,CreditCard ,FileText ,Plus ,SquarePen ,Trash2 ,Ticket ,Layers ,Check ,ShoppingCart ,Minus ,Tag ,RefreshCcw ,ArrowUp ,Percent ,Search ,Hourglass ,List ,Copy ,Hash ,
      Receipt ,LoaderCircle ,CircleX ,BanknoteArrowDown ,CloudUpload  ,CalendarDays ,Coins ,PiggyBank ,Trophy ,ChevronDown ,UserRoundCog ,User ,Folder ,CalendarX ,Euro ,ShieldCheck ,Send ,
      ArrowLeft ,LogIn ,MailCheck ,TriangleAlert ,CircleQuestionMark ,Inbox ,ClipboardList ,KeyRound 
    })
  ],
  exports: [
    LucideAngularModule
  ]
})
export class LucideIconsModule { }
